var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubblyDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3925.9 3608.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        fill: none;\n        stroke: #000;\n      }\n\n      .cls-1, .cls-3, .cls-4, .cls-6 {\n        stroke-width: 9.07px;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-linecap: round;\n      }\n\n      .cls-2, .cls-3, .cls-6 {\n        stroke-linejoin: round;\n      }\n\n      .cls-2, .cls-5 {\n        stroke-width: 9.07px;\n      }\n\n      .cls-7 {\n        stroke-width: 0px;\n      }\n\n      .cls-4, .cls-5 {\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 2890.03,
    cy: 2060.19,
    r: 79.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 2879.01,
    cy: 2723.34,
    r: 79.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 2037.42,
    cy: 2502.77,
    r: 79.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 2873.21,
    cy: 1367.55,
    r: 79.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1699.64,
    cy: 1587.39,
    r: 79.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1137.27,
    cy: 2067.1,
    r: 79.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 2027.11,
    cy: 1823.04,
    r: 79.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 855.38,
    cy: 1842.44,
    r: 79.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 856.69,
    cy: 2730.21,
    r: 79.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 2245.09,
    cy: 1367.55,
    r: 79.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 2601.51,
    cy: 677.09,
    r: 79.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 840.89,
    cy: 929.41,
    r: 79.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1910.62,
    cy: 929.41,
    r: 79.03
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1056.33,678.81c4.41,6.57,8.82,13.13,13.23,19.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1415.59,678.16h-29.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1386.4,699.15h29.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1104.75,
    y1: 683.45,
    x2: 1128.11,
    y2: 683.45
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m991.15,657.59v41.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1038.98,657.69v41.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 971.19,
    y1: 657.59,
    x2: 1011.1,
    y2: 657.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1331.97,657.59v41.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1312.02,
    y1: 657.59,
    x2: 1351.93,
    y2: 657.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1386.22,658.11v41.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1386.22,657.24h29.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1038.98,657.69h17.35c6.06.48,10.52,5.75,10.09,11.38-.39,5.07-4.66,9.34-10.09,9.74h-15.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1163.89,698.76v-41.11c.78.38,1.93.91,3.32,1.51,6.95,2.98,15.14,6.51,25.1,6.65,12.99.18,22.54-4.4,26.61-6.65,1.16-.54,2.32-1.08,3.49-1.62v41.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1259.34,678.74h15.84c5.43-.39,9.71-4.67,10.09-9.74.43-5.63-4.03-10.9-10.09-11.38h-17.35v41.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1098.64,698.73l6.11-16.14c3.3-8.36,6.61-16.73,9.91-25.09,1.32,0,2.65,0,3.97,0,3.09,8.12,6.17,16.27,9.24,24.45,2.1,5.6,4.19,11.19,6.27,16.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1481.56,669.39c-2.58-7.31-9.33-12.35-17-12.72-7.92-.38-15.31,4.28-18.43,11.65-.87,2.26-2.05,6.24-1.72,11.24.23,3.53,1.13,6.37,1.92,8.31,3.32,6.98,10.55,11.28,18.23,10.84,7.83-.45,14.62-5.74,17-13.25"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m3030.22,2970.84c-4.41-6.57-8.82-13.13-13.23-19.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2670.96,2971.49c9.79,0,19.57,0,29.36,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2700.15,2950.5c-9.67,0-19.35,0-29.02,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2981.79,
    y1: 2966.2,
    x2: 2958.44,
    y2: 2966.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m3095.4,2992.05v-41.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m3047.57,2991.96v-41.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3115.36,
    y1: 2992.05,
    x2: 3075.45,
    y2: 2992.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2754.58,2992.05c0-13.71,0-27.42,0-41.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2774.53,
    y1: 2992.05,
    x2: 2734.62,
    y2: 2992.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2700.32,2991.54c0-13.68,0-27.36,0-41.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2700.32,2992.41c-9.67,0-19.35,0-29.02,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m3047.57,2991.96h-17.35c-6.06-.48-10.52-5.75-10.09-11.38.39-5.07,4.66-9.34,10.09-9.74,5.28,0,10.56,0,15.84,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2922.66,2950.89v41.11c-.78-.38-1.93-.91-3.32-1.51-6.95-2.98-15.14-6.51-25.1-6.65-12.99-.18-22.54,4.4-26.61,6.65-1.16.54-2.32,1.08-3.49,1.62,0-13.73,0-27.46,0-41.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2827.21,2970.91h-15.84c-5.43.39-9.71,4.67-10.09,9.74-.43,5.63,4.03,10.9,10.09,11.38h17.35v-41.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2987.9,2950.92l-6.11,16.14c-3.3,8.36-6.61,16.73-9.91,25.09-1.32,0-2.65,0-3.97,0-3.09-8.12-6.17-16.27-9.24-24.45-2.1-5.6-4.19-11.19-6.27-16.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2604.99,2980.26c2.58,7.31,9.33,12.35,17,12.72,7.92.38,15.31-4.28,18.43-11.65.87-2.26,2.05-6.24,1.72-11.24-.23-3.53-1.13-6.37-1.92-8.31-3.32-6.98-10.55-11.28-18.23-10.84-7.83.45-14.62,5.74-17,13.25"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 2875.57,
    cy: 2502.77,
    r: 34.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1611.45,
    y: 598.05,
    width: 804.44,
    height: 158.07,
    rx: 79.03,
    ry: 79.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1611.47,
    y: 1048.7,
    width: 804.44,
    height: 158.07,
    rx: 79.03,
    ry: 79.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1062,
    y: 1744,
    width: 769.59,
    height: 158.07,
    rx: 79.03,
    ry: 79.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2276.12,
    y: 1738.57,
    width: 669.11,
    height: 158.07,
    rx: 79.03,
    ry: 79.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2255.15,
    y: 2426.1,
    width: 703.06,
    height: 158.07,
    rx: 79.03,
    ry: 79.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1856.94,
    y: 2199.27,
    width: 1096.1,
    height: 158.07,
    rx: 79.03,
    ry: 79.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1618.01,
    y: 2652.93,
    width: 1096.1,
    height: 158.07,
    rx: 79.03,
    ry: 79.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2571.71,
    y: 822.26,
    width: 613,
    height: 158.07,
    rx: 79.03,
    ry: 79.03,
    transform: "translate(3779.51 -1976.92) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1086.31,
    y: 1290.57,
    width: 597.75,
    height: 158.07,
    rx: 79.03,
    ry: 79.03,
    transform: "translate(2754.78 -15.58) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1151.33,
    y: 2647.74,
    width: 597.75,
    height: 158.07,
    rx: 79.03,
    ry: 79.03,
    transform: "translate(4176.98 1276.57) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 851.4,
    y: 2644.87,
    width: 597.75,
    height: 158.07,
    rx: 79.03,
    ry: 79.03,
    transform: "translate(3874.18 1573.63) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 557.82,
    y: 2199.27,
    width: 597.75,
    height: 158.07,
    rx: 79.03,
    ry: 79.03,
    transform: "translate(3134.99 1421.61) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1395.97,
    y: 2212.42,
    width: 597.75,
    height: 158.07,
    rx: 79.03,
    ry: 79.03,
    transform: "translate(3986.29 596.61) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2275.22,
    y: 1282.65,
    width: 623.33,
    height: 158.07,
    rx: 79.03,
    ry: 79.03,
    transform: "translate(3948.58 -1225.2) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2069.08,
    y: 850.38,
    width: 597.75,
    height: 158.07,
    rx: 79.03,
    ry: 79.03,
    transform: "translate(4735.91 1858.82) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1067.39,
    y: 2212.42,
    width: 463.38,
    height: 158.07,
    rx: 79.03,
    ry: 79.03,
    transform: "translate(2598.16 4582.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 763.38,
    y: 1050.02,
    width: 468.2,
    height: 158.07,
    rx: 79.03,
    ry: 79.03,
    transform: "translate(1994.97 2258.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2794.18,
    y: 1506.69,
    width: 503.82,
    height: 158.07,
    rx: 79.03,
    ry: 79.03,
    transform: "translate(6092.18 3171.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1960.77,
    y: 1508.36,
    width: 455.15,
    height: 158.07,
    rx: 79.03,
    ry: 79.03,
    transform: "translate(4376.68 3174.78) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1959.74,
    y: 1970.55,
    width: 710.18,
    height: 158.07,
    rx: 79.03,
    ry: 79.03,
    transform: "translate(4629.67 4099.17) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1604.01,
    y: 1288.52,
    width: 455.15,
    height: 158.07,
    rx: 79.03,
    ry: 79.03,
    transform: "translate(3663.17 2735.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1008.85,
    y: 850.89,
    width: 723.78,
    height: 158.07,
    rx: 79.03,
    ry: 79.03,
    transform: "translate(2741.48 1859.85) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 3032.72,
    y: 1855.26,
    width: 376.12,
    height: 157.82,
    rx: 78.91,
    ry: 78.91,
    transform: "translate(1286.61 5154.95) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1856.94,
    y: 2876.4,
    width: 680.71,
    height: 157.82,
    rx: 78.91,
    ry: 78.91,
    transform: "translate(4394.59 5910.61) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 667.31,
    y: 1399.16,
    width: 376.12,
    height: 157.82,
    rx: 78.91,
    ry: 78.91,
    transform: "translate(-622.69 2333.44) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 949.21,
    y: 1396.99,
    width: 376.12,
    height: 157.82,
    rx: 78.91,
    ry: 78.91,
    transform: "translate(-338.63 2613.17) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2902.25,
    y: 1057.18,
    width: 607.66,
    height: 157.82,
    rx: 78.91,
    ry: 78.91,
    transform: "translate(2069.99 4342.17) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2921.7,
    y: 2431.27,
    width: 595.52,
    height: 157.82,
    rx: 78.91,
    ry: 78.91,
    transform: "translate(709.29 5729.64) rotate(-90)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1694.84,
    cy: 677.09,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1152.5,
    cy: 1129.06,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 855.38,
    cy: 1585.72,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 855.38,
    cy: 2050.1,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1397.71,
    cy: 2050.1,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 2037.42,
    cy: 2049.59,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 2579.76,
    cy: 2050.67,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 3221.91,
    cy: 2050.67,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 2875.57,
    cy: 2505.13,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 2333.23,
    cy: 2502.77,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1693.52,
    cy: 2504.8,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1151.19,
    cy: 2502.77,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1150.19,
    cy: 2955.31,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1693.09,
    cy: 2955.31,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 2449.23,
    cy: 2955.31,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1385.4,
    cy: 1585.72,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 2038.76,
    cy: 1585.72,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 2586.07,
    cy: 1585.72,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 3221.91,
    cy: 1585.72,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1694.84,
    cy: 1126.85,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 2334.55,
    cy: 1128.06,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 2334.55,
    cy: 677.09,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 2878.21,
    cy: 677.09,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 2878.21,
    cy: 1129.83,
    rx: 36.85,
    ry: 36.76
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2035.19,3213.14c621.06,0,966.32,0,1191.82-225.5,225.5-225.5,225.5-570.76,225.5-1191.82s0-966.32-225.5-1191.82c-225.5-225.5-570.76-225.5-1191.82-225.5s-966.32,0-1191.82,225.5c-225.5,225.5-225.5,570.76-225.5,1191.82s0,966.32,225.5,1191.82c225.5,225.5,570.76,225.5,1191.82,225.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2035.19,3388.11c698.27,0,1086.44,0,1339.97-253.53,253.53-253.53,253.53-641.71,253.53-1339.97s0-1086.44-253.53-1339.97c-253.53-253.53-641.71-253.53-1339.97-253.53s-1086.44,0-1339.97,253.53c-253.53,253.53-253.53,641.71-253.53,1339.97s0,1086.44,253.53,1339.97c253.53,253.53,641.71,253.53,1339.97,253.53Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubblyDesign);
export default __webpack_public_path__ + "static/media/bubblyDesign.68fea2e01b436ed683db7b57fb9d585b.svg";
export { ForwardRef as ReactComponent };